<template>
    <header class="container mb-6 border-b border-primary/40 px-2 py-4">
        <div class="navbar">
            <div class="navbar-start items-center gap-x-3 sm:flex md:gap-x-6 lg:gap-x-12">
                <details ref="dropdown" class="dropdown sm:hidden">
                    <summary class="btn btn-circle btn-ghost">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             class="size-5"
                             fill="none"
                             viewBox="0 0 24 24"
                             stroke="currentColor">
                            <path stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M4 6h16M4 12h16M4 18h7" />
                        </svg>
                    </summary>
                    <ul tabindex="0"
                        class="menu-sm menu dropdown-content z-50 mt-3 w-52 rounded-box
                           bg-base-100/50 p-2 shadow backdrop-blur backdrop-brightness-110">
                        <li>
                            <NuxtLink :to="{ name: 'index' }" @click="handleDropdownClick('index')">
                                Homepage
                            </NuxtLink>
                        </li>
                        <li>
                            <NuxtLink :to="{ name: 'products' }"
                                      prefetch
                                      @click="handleDropdownClick('products')">
                                Products
                            </NuxtLink>
                        </li>
                        <li>
                            <NuxtLink :to="{ name: 'about' }" @click="handleDropdownClick('about')">
                                About
                            </NuxtLink>
                        </li>
                        <li>
                            <NuxtLink :to="{ name: 'contact' }"
                                      @click="handleDropdownClick('contact')">
                                Contact&nbsp;Me
                            </NuxtLink>
                        </li>
                        <li>
                            <NuxtLink :to="{ name: 'galleries' }"
                                      @click="handleDropdownClick('galleries')">
                                Galleries
                            </NuxtLink>
                        </li>
                        <li>
                            <NuxtLink :to="{ name: 'faqs' }" @click="handleDropdownClick('faqs')">
                                FAQs
                            </NuxtLink>
                        </li>
                    </ul>
                </details>
            </div>
            <div class="navbar-center">
                <NuxtLink to="/" title="Homepage" aria-label="Homepage">
                    <Logo class="size-16 opacity-70 transition-colors" />
                </NuxtLink>
            </div>
            <div class="navbar-end" />
        </div>
        <nav class="navbar hidden sm:flex">
            <div class="navbar-center mx-auto flex w-full flex-row items-center justify-evenly gap-x-3 md:gap-x-6
                        lg:gap-x-12 xl:w-3/5">
                <NuxtLink :to="{ name: 'products' }">
                    Products
                </NuxtLink>
                <NuxtLink :to="{ name: 'galleries' }">
                    Galleries
                </NuxtLink>
                <NuxtLink :to="{ name: 'about' }">
                    About
                </NuxtLink>
                <NuxtLink :to="{ name: 'contact' }">
                    Contact&nbsp;Me
                </NuxtLink>
                <NuxtLink :to="{ name: 'faqs' }">
                    FAQs
                </NuxtLink>
            </div>
        </nav>
    </header>
</template>

<script setup lang="ts">

defineOptions({
    name: 'HeaderSection'
})

const dropdown = ref<HTMLDetailsElement>();
const route = useRoute();

onClickOutside(dropdown, () => {
    if (!dropdown.value) return;
    dropdown.value.open = false;
});

const handleDropdownClick = (routeName: string) => {
    if (!dropdown.value) return;
    dropdown.value.open = routeName === route.name;
};
</script>
